import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ElearningSchoolComponent } from './components/pages/elearning-school/elearning-school.component';
import { ContactComponent } from './components/custom/contact/contact.component';
import { GalleryComponent } from './components/custom/gallery/gallery.component';
import { GalleryAchieversComponent } from './components/custom/gallery/achievers/achievers.component';
import { InfraComponent } from './components/custom/gallery/infra/infra.component';
import { AboutFourComponent } from './components/custom/about/about-four/about-four.component';
import { CategoryCourseListComponent } from './components/custom/category-course-list/category-course-list.component';
import { SampleVideoComponent } from './components/custom/category-course-list/sample-video/sample-video.component';
import { SampleMaterialComponent } from './components/custom/category-course-list/sample-material/sample-material.component';
import { SampleTestComponent } from './components/custom/category-course-list/sample-test/sample-test.component';
import { PreviousyearqpComponent } from './components/custom/category-course-list/previousyearqp/previousyearqp.component';
import { SyllabusComponent } from './components/custom/category-course-list/syllabus/syllabus.component';
import { TermsAndConditionsComponent } from "./components/pages/terms-and-conditions/terms-and-conditions.component";
import { BlogsComponent } from './components/common/blogs/blogs.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { BlogsDetailsComponent } from './components/common/blogs-details/blogs-details.component';

const routes: Routes = [
    { path: '', component: ElearningSchoolComponent },
    { path: 'gallery', component: GalleryComponent },
    { path: 'gallery/achievers', component: GalleryAchieversComponent },
    { path: 'gallery/infra', component: InfraComponent },
    { path: 'contact', component: ContactComponent },
    { path: 'about', component: AboutFourComponent },
    { path: 'courses/:name', component: CategoryCourseListComponent },

    // test batch series
    {
        path: ':categoryName/:courseName/explanation-video',
        component: SampleVideoComponent,
        data: {
            group: 'Test Batch Series',
            groupRoute: 'test-batch-series',
            page: 'explanation-video',
            pageName: 'Explanation Video',
        },
    },
    {
        path: ':categoryName/:courseName/test-schedule',
        component: SyllabusComponent,
        data: {
            group: 'Test Batch Series',
            groupRoute: 'test-batch-series',
            page: 'test-schedule',
            pageName: 'Test Schedule',
        },
    },

    // materials
    {
        path: ':categoryName/:courseName/material/sample-materials',
        component: SyllabusComponent,
        data: {
            group: 'Materials',
            groupRoute: 'material',
            page: 'sample-materials',
            pageName: 'Materials',
        },
    },

    // course
    {
        path: ':categoryName/:courseName/sample-classes',
        component: SampleVideoComponent,
        data: {
            group: 'Course',
            groupRoute: 'course',
            page: 'sample-classes',
            pageName: 'Sample Classes',
        },
    },
    { path: ':courseName/sample-classes', component: SampleVideoComponent },

    {
        path: ':categoryName/:courseName/sample-materials',
        component: SampleMaterialComponent,
    },
    {
        path: ':courseName/sample-materials',
        component: SampleMaterialComponent,
    },
    {
        path: ':categoryName/:courseName/sample-test',
        component: SampleTestComponent,
        data: {
            group: 'Course',
            groupRoute: 'course',
            page: 'sample-test',
            pageName: 'Sample Tests',
        },
    },
    { path: ':courseName/sample-test', component: SampleTestComponent },

    {
        path: ':categoryName/:courseName/previous-year-qp',
        component: PreviousyearqpComponent,
    },
    {
        path: ':courseName/previous-year-qp',
        component: PreviousyearqpComponent,
    },

    {
        path: ':categoryName/:courseName/syllabus',
        component: SyllabusComponent,
        data: {
            group: 'Course',
            groupRoute: 'course',
            page: 'syllabus',
            pageName: 'Syllabus',
        },
    },
    { path: ':courseName/syllabus', component: SyllabusComponent },
    { path: 'terms_conditions', component: TermsAndConditionsComponent },
    { path: 'blogs', component: BlogsComponent },
    { path: 'blogs-details', component: BlogsDetailsComponent },
    // { path: 'privacy-policy', component: PrivacyPolicyComponent },
    // { path: 'terms-of-service', component: TermsOfServiceComponent },
    // { path: 'gallery', component: GalleryComponent },
    // { path: 'vendor-certification-etraining', component: VendorCertificationEtrainingComponent },
    // { path: 'online-training-school', component: OnlineTrainingSchoolComponent },
    // { path: 'distance-learning', component: DistanceLearningComponent },
    // { path: 'language-school', component: LanguageSchoolComponent },
    // { path: 'modern-schooling', component: ModernSchoolingComponent },
    // { path: 'yoga-training', component: YogaTrainingComponent },
    // { path: 'health-coaching', component: HealthCoachingComponent },
    // { path: 'kindergarten', component: KindergartenComponent },
    // { path: 'gym-coaching', component: GymCoachingComponent },
    // { path: 'learning-management', component: LearningManagementComponent },
    // { path: 'business-coaching', component: BusinessCoachingComponent },
    // { path: 'motivational-coaching', component: MotivationalCoachingComponent },
    // { path: 'kitchen-coaching', component: KitchenCoachingComponent },
    // { path: 'online-art', component: OnlineArtComponent },
    // { path: 'single-instructor', component: SingleInstructorComponent },
    // { path: 'about-1', component: AboutStyleOneComponent },
    // { path: 'about-2', component: AboutStyleTwoComponent },
    // { path: 'about-3', component: AboutStyleThreeComponent },
    // { path: 'about-4', component: AboutStyleFourComponent },
    // { path: 'success-story', component: SuccessStoryComponent },
    // { path: 'teacher', component: TeacherComponent },
    // { path: 'profile-authentication', component: ProfileAuthenticationComponent },
    // { path: 'faq', component: FaqComponent },
    // { path: 'coming-soon', component: ComingSoonComponent },
    // { path: 'purchase-guide', component: PurchaseGuideComponent },
    // { path: 'profile', component: ProfileComponent },
    // { path: 'profile-quiz', component: ProfileQuizComponent },
    // { path: 'membership-levels', component: MembershipLevelsComponent },
    // { path: 'become-a-teacher', component: BecomeATeacherComponent },
    // { path: 'categories', component: CategoriesComponent },
    // { path: 'events', component: EventsComponent },
    // { path: 'single-events', component: EventsDetailsComponent },
    // { path: 'products-list-1', component: ProductsListStyleOneComponent },
    // { path: 'products-list-2', component: ProductsListStyleTwoComponent },
    // { path: 'cart', component: CartComponent },
    // { path: 'checkout', component: CheckoutComponent },
    // { path: 'single-products', component: ProductsDetailsComponent },
    // { path: 'blog-1', component: BlogStyleOneComponent },
    // { path: 'blog-2', component: BlogStyleTwoComponent },
    // { path: 'blog-3', component: BlogStyleThreeComponent },
    // { path: 'blog-4', component: BlogStyleFourComponent },
    // { path: 'blog-5', component: BlogStyleFiveComponent },
    // { path: 'single-blog-1', component: BlogDetailsStyleOneComponent },
    // { path: 'single-blog-2', component: BlogDetailsStyleTwoComponent },
    // { path: 'single-blog-3', component: BlogDetailsStyleThreeComponent },
    // { path: 'courses-1', component: CoursesStyleOneComponent },
    // { path: 'courses-2', component: CoursesStyleTwoComponent },
    // { path: 'courses-3', component: CoursesStyleThreeComponent },
    // { path: 'courses-4', component: CoursesStyleFourComponent },
    // { path: 'courses-5', component: CoursesStyleFiveComponent },
    // { path: 'courses-6', component: CoursesStyleSixComponent },
    // { path: 'courses-7', component: CoursesStyleSevenComponent },
    // { path: 'single-courses-1', component: CoursesDetailsStyleOneComponent },
    // { path: 'single-courses-2', component: CoursesDetailsStyleTwoComponent },
    // Here add new pages component
    { path: '**', component: ErrorComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: false })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
